import Lock from "@/assets/icons/lock.svg?react";
import Level from "@/assets/images/achievements/level.svg?react";
import { COMING_SOON } from "@/constants";
import { convertNumberToRoman } from "@/utils/convertToRoman";

import styles from "./styles";

export const AchievementLevel = ({
  index,
  level,
  levels,
  handler,
  iconLevel = <Level />,
}: {
  index: number;
  level: { text: string; complete: boolean };
  levels: Array<{ text: string; complete: boolean }>;
  handler: () => void;
  iconLevel?: JSX.Element;
}) => {
  return (
    <styles.Achievement.Level
      key={index}
      onClick={handler}
      $completed={level.complete}
      $level={index + 1}
      $prevCompleted={levels[index + 1]?.complete || false}
    >
      <span>{level.text === COMING_SOON ? <Lock /> : convertNumberToRoman(index + 1)}</span>
      {iconLevel}
    </styles.Achievement.Level>
  );
};
